import { render, staticRenderFns } from "./PropostaComercial.vue?vue&type=template&id=48f1c1af&"
import script from "./PropostaComercial.vue?vue&type=script&lang=js&"
export * from "./PropostaComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports